import { getSkillRating, SkillRating, SkillRatingId } from '~/monolith-api';
import { useRegisteredQuery } from '~/queries';

const KEY = 'skill-rating';

export function useSkillRating(skillRatingId: SkillRatingId, teamid?: number) {
   return useRegisteredQuery(
      [KEY, skillRatingId, teamid],
      async (): Promise<SkillRating | null> => {
         return await getSkillRating(skillRatingId, teamid);
      }
   );
}
